import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";

const DeleteBlog = () => {
  const [deletedBlogs, setDeletedBlogs] = useState([]);

  const apiEndpoint = "https://jacobjose.azurewebsites.net/api/dashboard/deleteblogs";

  useEffect(() => {
    axios.get(apiEndpoint)
      .then((response) => {
        setDeletedBlogs(response.data);
      })
      .catch((error) => {
        console.error("Error fetching deleted blogs:", error);
      });
  }, []);

  return (
    <div className="delete-blog">
      {deletedBlogs.map((blog, index) => (
        <div key={index} className="deleted-blog">
          <h3>{blog.header}</h3>
          <p>Date: {blog.date}</p>
          <p>{blog.content}</p>
        </div>
      ))}
    </div>
  );
};

export default DeleteBlog;
